import { render, staticRenderFns } from "./th-ordering-button.vue?vue&type=template&id=3c0f5037&scoped=true"
import script from "./th-ordering-button.vue?vue&type=script&lang=js"
export * from "./th-ordering-button.vue?vue&type=script&lang=js"
import style0 from "./th-ordering-button.vue?vue&type=style&index=0&id=3c0f5037&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f5037",
  null
  
)

export default component.exports